export const InfoEtapesParcours = {
  TDB: {
    descriptionSection: {
      fr: 'Tableau de bord',
      en: 'Dashboard'
    },
    tdb: {
      codePage: '001',
      descriptionPage: {
        fr: "Tableau de bord de l'application",
        en: 'Dashboard'
      }
    }
  },
  CAPFIN: {
    descriptionSection: {
      fr: 'Capacité financière',
      en: 'Borrowing capacity'
    },
    page_accueil_capfin: {
      codePage: '00a',
      descriptionPage: {
        fr: 'Ma capacité financière',
        en: 'My budget'
      }
    },
    aiguilleur_type_propriete: {
      codePage: '00b',
      descriptionPage: {
        fr: 'Quel type de propriété recherchez-vous?',
        en: 'What type of property are you looking for?'
      }
    },
    revenus: {
      codePage: '001',
      descriptionPage: {
        fr: 'Quel est votre revenu?',
        en: 'What is your income?'
      }
    },
    mise_de_fond: {
      codePage: '003',
      descriptionPage: {
        fr: 'Quel est le montant approximatif de votre mise de fonds?',
        en: 'What kind of down payment can you afford?'
      }
    },
    dettes: {
      codePage: '004',
      descriptionPage: {
        fr: 'Quelles sont vos dettes actuelles?',
        en: 'What debts do you have?'
      }
    },
    budget: {
      codePage: '005',
      descriptionPage: {
        fr: 'Calculez combien vous pouvez payer pour votre maison',
        en: 'How much can you afford to spend on a home'
      }
    },
    depenses: {
      codePage: '005a',
      descriptionPage: {
        fr: 'Combien dépensez-vous chaque mois?',
        en: 'How much do you spend every month?'
      }
    },
    paiement: {
      codePage: '005b',
      descriptionPage: {
        fr: 'Combien voulez-vous payer chaque mois pour rembourser votre maison?',
        en: 'How much do you want to pay for your home each month?'
      }
    },
    page_resultats: {
      codePage: '006',
      descriptionPage: {
        fr: 'Mon résultat',
        en: 'Result'
      }
    },
    hypotheque: {
      codePage: '007',
      descriptionPage: {
        fr: 'Quels sont les paiements liés à votre propriété actuelle?',
        en: 'What payments do you make on your current home?'
      }
    },
    non_eligible_general: {
      codePage: '0Z0',
      descriptionPage: {
        fr: 'Profitez d’un accompagnement sur mesure',
        en: 'Enjoy personalized support'
      }
    },
    non_eligible_type_propriete: {
      codePage: '0Z2',
      descriptionPage: {
        fr: 'Profitez d’un accompagnement sur mesure | Type de propriété | Autre (plex, commerce ou terrain)',
        en: 'Enjoy personalized support | Type of property | Other (multiplex, commercial property or land)'
      }
    },
    non_eligible_type_projet: {
      codePage: '0Z3',
      descriptionPage: {
        fr: 'Profitez d’un accompagnement sur mesure | Type de projet | Autre (obtenir un revenu locatif)',
        en: 'Enjoy personalized support | Type of projet |Other (earn rental income)'
      }
    }
  },
  PROP: {
    descriptionSection: {
      fr: 'Propriété',
      en: 'Property'
    },
    liste: {
      codePage: '001',
      descriptionPage: {
        fr: 'Paiement et frais',
        en: 'Payment and costs'
      }
    },
    creation: {
      codePage: '002',
      descriptionPage: {
        fr: 'Ajouter une propriété',
        en: 'Add a property'
      }
    },
    detail: {
      codePage: '003',
      descriptionPage: {
        fr: 'Détails de la propriété',
        en: 'Property details'
      }
    }
  },
  PREAUTEXP: {
    descriptionSection: {
      fr: 'Préautorisation',
      en: 'Pre-approval'
    },
    page_accueil: {
      codePage: '000',
      descriptionPage: {
        fr: 'Ma préautorisation',
        en: 'Pre-approval'
      }
    },
    etape_type_propriete: {
      codePage: '00b',
      descriptionPage: {
        fr: 'Quel type de propriété recherchez-vous?',
        en: 'What type of property are you looking for?'
      }
    },
    aiguilleur_residence_principale: {
      codePage: '0Z6',
      descriptionPage: {
        fr: 'Cette propriété sera-t-elle votre résidence principale?',
        en: 'Will this property be your primary residence?'
      }
    },
    aiguilleur_projet: {
      codePage: '00c',
      descriptionPage: {
        fr: 'Que prévoyez-vous?',
        en: 'What are you planning to do?'
      }
    },
    aiguilleur_salarie: {
      codePage: '00d',
      descriptionPage: {
        fr: 'Êtes-vous salarié?',
        en: 'Do you work for an employer?'
      }
    },
    aiguilleur_multiproprietaire: {
      codePage: '00e',
      descriptionPage: {
        fr: 'Avez-vous plus d’une propriété?',
        en: 'Do you have more than one property?'
      }
    },
    etape_coemprunteur: {
      codePage: '00f',
      descriptionPage: {
        fr: 'Achetez-vous à deux?',
        en: 'Are you buying with a co-borrower?'
      }
    },
    etape_consentement: {
      codePage: '00g',
      descriptionPage: {
        fr: 'Déclarations et consentement',
        en: 'Statement and Consents'
      }
    },
    etape_revenu_brut: {
      codePage: '00h',
      descriptionPage: {
        fr: 'Quel est votre revenu brut?',
        en: 'What’s your gross income?'
      }
    },
    etape_acheter_a_deux: {
      codePage: '00i',
      descriptionPage: {
        fr: 'Avez-vous acheté votre propriété actuelle avec une autre personne?',
        en: 'Did you buy your current property with another person?'
      }
    },
    etape_meme_coemprunteur: {
      codePage: '00j',
      descriptionPage: {
        fr: 'Est-ce le même coemprunteur que celui avec qui vous achetez une résidence secondaire?',
        en: 'Is it the same co-borrower with whom you are buying a second home?'
      }
    },
    etape_hypotheque: {
      codePage: '00k',
      descriptionPage: {
        fr: 'Quels sont les paiements liés à votre propriété actuelle?',
        en: 'What payments do you make on your current home?'
      }
    },
    etape_prix_propriete: {
      codePage: '00l',
      descriptionPage: {
        fr: 'À quel prix prévoyez-vous acheter votre propriété?',
        en: 'How much do you plan to spend on your home?'
      }
    },
    etape_revenu_locatif: {
      codePage: '00x',
      descriptionPage: {
        fr: 'Revenu de locaton estimé',
        en: 'Approximate rental income'
      }
    },
    etape_mise_de_fonds: {
      codePage: '00m',
      descriptionPage: {
        fr: 'Quel est le montant approximatif de votre mise de fonds?',
        en: 'What’s the approximate amount of your down payment?'
      }
    },
    etape_coordonnees: {
      codePage: '00n',
      descriptionPage: {
        fr: 'Vous contacter',
        en: 'Have us contact you'
      }
    },
    etape_recap: {
      codePage: '00o',
      descriptionPage: {
        fr: 'Soumettre votre demande',
        en: 'Submit your application'
      }
    },
    etape_accepter_projet: {
      codePage: '00p',
      descriptionPage: {
        fr: 'Accepter le projet',
        en: 'Confirm project'
      }
    },
    page_details: {
      codePage: '00q',
      descriptionPage: {
        fr: 'Ma preautorisation',
        en: 'Pre-approval'
      }
    },
    resultat_accepte: {
      codePage: '00r',
      descriptionPage: {
        fr: 'Votre demande de préautorisation a été acceptée.',
        en: 'You’ve been pre-approved.'
      }
    },
    resultat_refuse: {
      codePage: '00s',
      descriptionPage: {
        fr: 'Nous avons besoin de renseignements supplémentaires pour continuer l’analyse de votre demande.',
        en: 'We need some additional information to continue analyzing your application.'
      }
    },
    resultat_contre_offre_attente: {
      codePage: '00t',
      descriptionPage: {
        fr: 'Une proposition adaptée à votre budget',
        en: 'A proposal that suits your budget'
      }
    },
    resultat_attente_selection_taux: {
      codePage: '00u',
      descriptionPage: {
        fr: 'Réserver votre taux',
        en: 'Lock in your rate'
      }
    },
    resultat_en_attente_coemprunteur: {
      codePage: '00v',
      descriptionPage: {
        fr: 'Au tour de votre coemprunteur',
        en: "It’s your co-borrower's turn"
      }
    },
    resultat_attente: {
      codePage: '00w',
      descriptionPage: {
        fr: 'Nous traitons votre demande',
        en: 'We’re processing your application'
      }
    },
    non_eligible_type_propriete: {
      codePage: '0Zb',
      descriptionPage: {
        fr: 'Profitez d’un accompagnement sur mesure | Quel type de propriété recherchez-vous? | Autre',
        en: 'Enjoy personalized support | What type of property are you looking for? | Other'
      }
    },
    non_eligible_residence_principale: {
      codePage: '0Z7',
      descriptionPage: {
        fr: 'Profitez d’un accompagnement sur mesure | La propriété sera votre résidence principale? | Non',
        en: 'Enjoy personalized support | Will this property be your primary residence? | No'
      }
    },
    non_eligible_projet: {
      codePage: '0Zc',
      descriptionPage: {
        fr: 'Profitez d’un accompagnement sur mesure | Que prévoyez-vous? | Autre',
        en: 'Enjoy personalized support | What are you planning to do? | Other'
      }
    },
    non_eligible_salarie: {
      codePage: '0Zd',
      descriptionPage: {
        fr: 'Profitez d’un accompagnement sur mesure | Êtes-vous salarié? | Non',
        en: 'Enjoy personalized support | Do you work for an employer? | No'
      }
    },
    page_preaut_en_cours: {
      codePage: '0Zf',
      descriptionPage: {
        fr: 'Vous avez déjà une préautorisation active | Continuons ensemble',
        en: 'You already have an existing pre-approval | Let’s continue together'
      }
    },
    page_panne: {
      codePage: '0Zh',
      descriptionPage: {
        fr: 'La préautorisation n’est pas disponible pour l’instant',
        en: 'The pre-approval feature is currently unavailable'
      }
    },
    page_code_invitation: {
      codePage: '0Zi',
      descriptionPage: {
        fr: 'Entrez le code d’invitation',
        en: 'Enter the invite code'
      }
    },
    page_annule_par_coemprunteur: {
      codePage: '0Zj',
      descriptionPage: {
        fr: 'Votre coemprunteur a récemment annulé votre demande conjointe',
        en: 'Your co-borrower recently canceled your joint application'
      }
    },
    page_fonction_inactive_taux: {
      codePage: '007',
      descriptionPage: {
        fr: 'Les taux ne sont pas disponibles pour l’instant',
        en: 'The rate selection is currently unavailable'
      }
    },
    non_eligible_citoyennete: {
      codePage: '01a',
      descriptionPage: {
        fr: 'Vous n’avez pas la citoyenneté ou la résidence permanente au Canada.',
        en: 'You’re not a Canadian citizen or permanent resident.'
      }
    },
    aiguilleur_citoyennete: {
      codePage: '01b',
      descriptionPage: {
        fr: 'Avez-vous la citoyenneté canadienne ou la résidence permanente au Canada?',
        en: 'Are you a Canadian citizen or permanent resident?'
      }
    }
  },
  PREAUT: {
    descriptionSection: {
      fr: 'Ma préautorisation',
      en: 'My preapproval'
    },
    accueil: {
      codePage: '001',
      descriptionPage: {
        fr: "Les avantages d'une préautorisation",
        en: 'Benefits of getting pre-approved'
      }
    },
    question_coemprunteur: {
      codePage: '007',
      descriptionPage: {
        fr: 'Achetez-vous avec un coemprunteur?',
        en: 'Are you buying with a co-borrower?'
      }
    },
    question_type_propriete: {
      codePage: '009',
      descriptionPage: {
        fr: 'Quel type de propriété recherchez-vous?',
        en: 'What type of property are you looking for?'
      }
    },
    question_residence_principale: {
      codePage: '00A',
      descriptionPage: {
        fr: 'Vous confirmez que cette propriété sera votre résidence principale?',
        en: 'Will this property be your primary residence?'
      }
    },
    question_salarie: {
      codePage: '00B',
      descriptionPage: {
        fr: 'Êtes-vous salarié?',
        en: 'Do you work for an employer?'
      }
    },
    question_emploi_actuel: {
      codePage: '00C',
      descriptionPage: {
        fr: 'Parlons de votre emploi actuel',
        en: 'Tell us about your current job'
      }
    },
    question_employeur_actuel: {
      codePage: '00D',
      descriptionPage: {
        fr: 'Passons à votre employeur',
        en: 'Tell us about your employer'
      }
    },
    question_revenu_brut: {
      codePage: '00E',
      descriptionPage: {
        fr: 'Votre revenu brut',
        en: 'Your gross income'
      }
    },
    question_logement: {
      codePage: '00F',
      descriptionPage: {
        fr: 'Parlons de votre logement',
        en: 'What about housing?'
      }
    },
    question_prix_propriete: {
      codePage: '00G',
      descriptionPage: {
        fr: 'À quel prix prévoyez-vous acheter votre propriété?',
        en: 'How much do you plan to spend on your home?'
      }
    },
    question_mise_de_fond: {
      codePage: '00H',
      descriptionPage: {
        fr: 'Votre mise de fonds',
        en: 'Your down payment'
      }
    },
    question_coordonnees: {
      codePage: '00I',
      descriptionPage: {
        fr: 'Vos coordonnées',
        en: 'Your contact information'
      }
    },
    page_recap_preautorisation: {
      codePage: '00J',
      descriptionPage: {
        fr: 'Un dernier coup d’œil avant d’envoyer votre demande de rendez-vous',
        en: 'Review your application'
      }
    },
    page_declaration_consentement: {
      codePage: '00K',
      descriptionPage: {
        fr: 'Déclarations et consentements',
        en: 'Statement and Consent'
      }
    },
    page_demande_envoyee: {
      codePage: '00L',
      descriptionPage: {
        fr: 'Demande envoyée!',
        en: 'Application sent!'
      }
    },
    page_demande_acceptee: {
      codePage: '00M',
      descriptionPage: {
        fr: 'Préautorisation acceptée',
        en: 'You’ve been pre-approved'
      }
    },
    question_proposition: {
      codePage: '00N',
      descriptionPage: {
        fr: 'Renseignements partagés par coemprunteur1',
        en: 'Information provided by co-borrower'
      }
    },
    page_invitation_code: {
      codePage: '00O',
      descriptionPage: {
        fr: 'Entrer votre code d’invitation',
        en: 'Enter an invite code'
      }
    },
    page_traitement_refusee: {
      codePage: '00P',
      descriptionPage: {
        fr: 'Votre situation a changé?',
        en: 'Has your situation changed?'
      }
    },
    page_traitement_annulee: {
      codePage: '00Q',
      descriptionPage: {
        fr:
          'Nous avons tenté de vous joindre au cours des derniers jours, sans succès. Votre demande de préautorisation a donc été annulée.',
        en:
          'We tried to contact you over the past few days but were unable to reach you. We therefore had to cancel your preapproval application.'
      }
    },
    page_traitement_refusee_simplifie: {
      codePage: '00R',
      descriptionPage: {
        fr: 'Nous avons quelques questions à vous poser pour mieux vous connaître.',
        en: 'We’d like to ask you a few questions to get to know you better.'
      }
    },
    page_traitement_en_annulation: {
      codePage: '00S',
      descriptionPage: {
        fr: 'Nous traitons votre demande',
        en: 'We’re processing your application.'
      }
    },
    page_traitement_en_attente_coemprunteur: {
      codePage: '00T',
      descriptionPage: {
        fr: 'Au tour de votre coemprunteur maintenant!',
        en: 'Now it’s your co-borrower’s turn!'
      }
    },
    page_traitement_en_attente: {
      codePage: '00U',
      descriptionPage: {
        fr: 'Nous traitons votre demande',
        en: 'We’re processing your application.'
      }
    },
    page_panne_preadmissibilite: {
      codePage: '00R',
      descriptionPage: {
        fr: 'Aïe! Incident technique',
        en: 'Oops! Something went wrong.'
      }
    },
    page_contre_offre: {
      codePage: '00S',
      descriptionPage: {
        fr: 'Une proposition adaptée à votre budget',
        en: 'A proposal that suits your budget'
      }
    },
    non_eligible_salarie: {
      codePage: '0Z1',
      descriptionPage: {
        fr: 'Profitez d’un accompagnement sur mesure',
        en: 'Enjoy personalized support'
      }
    },
    non_eligible_type_propriete: {
      codePage: '0Z2',
      descriptionPage: {
        fr: 'Profitez d’un accompagnement sur mesure',
        en: 'Enjoy personalized support'
      }
    },
    non_eligible_residence_principale: {
      codePage: '0Z3',
      descriptionPage: {
        fr: 'Profitez d’un accompagnement sur mesure',
        en: 'Enjoy personalized support'
      }
    },
    non_eligible_authentification: {
      codePage: '0Z4',
      descriptionPage: {
        fr: 'Besoin d’accompagnement? Appelez-nous, nous trouverons une solution ensemble.',
        en: 'Need help? Give us a call. We’ll figure it out together.'
      }
    },
    page_choix_taux: {
      codePage: '0Z5',
      descriptionPage: {
        fr: 'Choisir votre taux',
        en: 'Select your rate'
      }
    }
  },
  OFFRE: {
    descriptionSection: {
      fr: "Offre d'achat",
      en: 'Purchase offer'
    },
    offre_achat: {
      codePage: '001',
      descriptionPage: {
        fr: "Page Mon offre d'achat et mon inspection",
        en: 'My purchase offer and my inspection'
      }
    }
  },
  ACTEV: {
    descriptionSection: {
      fr: 'Acte de vente',
      en: 'Closing day'
    },
    acte_vente: {
      codePage: '001',
      descriptionPage: {
        fr: 'Page mon acte de vente',
        en: 'Page my closing day'
      }
    }
  },
  EMNGMNT: {
    descriptionSection: {
      fr: 'Déménagement',
      en: 'Moving day'
    },
    emmenagement: {
      codePage: '001',
      descriptionPage: {
        fr: "L'aide-mémoire déménagement",
        en: 'Check-list my moving day'
      }
    }
  },
  OCTROI: {
    descriptionSection: {
      fr: 'Mon prêt et mes assurances',
      en: 'My mortgage and insurance'
    },
    accueil_pret: {
      codePage: '001A',
      descriptionPage: {
        fr: 'Mon type de prêts',
        en: 'My mortgage type'
      }
    },
    accueil_assurance: {
      codePage: '001B',
      descriptionPage: {
        fr: 'Protéger mon prêt',
        en: 'Insure my mortgage'
      }
    },
    assurance_habitation: {
      codePage: '001C',
      descriptionPage: {
        fr: 'Protéger ma maison',
        en: 'Protect my home'
      }
    },
    rendez_vous: {
      codePage: '002',
      descriptionPage: {
        fr: 'Formulaire rendez-vous',
        en: 'Make an appointment'
      }
    },
    recap: {
      codePage: '003',
      descriptionPage: {
        fr: 'Validez vos informations',
        en: 'Confirm your information'
      }
    },
    confirmation: {
      codePage: '004',
      descriptionPage: {
        fr: 'Page de confirmation de demande envoyée',
        en: 'Request sent page'
      }
    }
  }
};
